import { notStarted } from 'ocfe/src/utils/loadable';
import React from 'react';
import { useFilePickerConfig } from './api';

export type FilePickerConfig = {
    fsSetKey: string;
};

type FilePickerConfigLoadableValue = ReturnType<typeof useFilePickerConfig>;

const FilePickerContext = React.createContext<FilePickerConfigLoadableValue>([notStarted(), () => {}]);
FilePickerContext.displayName = 'FilePickerContext';
export { FilePickerContext };
